import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO/SEO';
import LatestPost from '../components/LatestPost/LatestPost';
import LatestNews from '../components/LatestNews/LatestNews';
import SidebarSponsor from '../components/Sidebars/SidebarSponsor/SidebarSponsor';
import { useArticles } from '../api/fetchExampleData';
import DualBlock from '../components/DualBlock/DualBlock';
import AdSenseSidebar from '../components/ADSense/AdSenseSidebar/AdSenseSidebar';
import AdSenseArticle from '../components/ADSense/AdSenseArticle/AdSenseArticle';
import AdSenseArticleMobile from '../components/ADSense/AdSenseArticle/AdSenseArticleMobile';

const Home = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [latestPostArticles, setLatestPostArticles] = useState([]);
  const [latestNewsArticles, setLatestNewsArticles] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [adsLoaded, setAdsLoaded] = useState(false);

  const { data: response } = useArticles({ page: currentPage, perPage: 10 });
  const articles = response?.data || [];
  const meta = response?.meta || {};

  // Aggiorna lo stato solo se necessario
  useEffect(() => {
    if (articles.length > 0 && currentPage === 1) {
      setLatestPostArticles((prev) =>
        prev.length === 0 ? articles.slice(0, 4) : prev // Evita aggiornamenti inutili
      );
      setLatestNewsArticles((prev) =>
        prev.length === 0 ? articles.slice(4) : prev // Evita aggiornamenti inutili
      );
    } else if (currentPage > 1 && articles.length > 0) {
      setLatestNewsArticles((prev) =>
        [...prev, ...articles].filter(
          (article, index, self) => self.findIndex((a) => a.id === article.id) === index
        )
      );
    }
  }, [articles, currentPage]);

  // Funzione per caricare la pagina successiva
  const handleLoadMore = () => {
    if (meta.total_pages && currentPage < meta.total_pages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const checkAdsLoaded = () => {
      // Verifica se gli annunci sono stati caricati
      const ads = document.querySelectorAll('.adsbygoogle');
      const adsLoaded = Array.from(ads).every(ad => ad.getAttribute('data-adsbygoogle-status') === 'done');
      setAdsLoaded(adsLoaded);
    };

    // Aggiungi un listener per verificare quando gli annunci sono caricati
    window.addEventListener('load', checkAdsLoaded);
    return () => window.removeEventListener('load', checkAdsLoaded);
  }, []);

  return (
    <>
      {latestPostArticles && latestNewsArticles && (
        <>
          <SEO title="Rossomotori.it" description="Homepage Rossomotori.it" url="https://rossomotori.it/" />
          {latestPostArticles.length > 0 && <LatestPost articles={latestPostArticles} />}
          {!isMobile && adsLoaded && <AdSenseArticle />}
          {latestNewsArticles.length > 0 && (
            <LatestNews
              articles={latestNewsArticles}
              meta={meta}
              onLoadMore={handleLoadMore}
              title="Ultime notizie"
              sidebarChildren={[
                [
                  <SidebarSponsor key="sponsor1-block1" logo="sponsor1.png" text="Sponsor 1" />,
                  adsLoaded && <AdSenseSidebar key="ads-block1" />,
                ],
              ]}
              maxMobileSidebars={1}
            >
              <DualBlock />
            </LatestNews>
          )}
        </>
      )}
    </>
  );
};

export default Home;